import { useSupabaseQuery } from './useSupabaseQuery';
import type { ProdigiOrder, LobOrder } from '../types/database';

export function useProdigiOrders(orderId: string | undefined) {
	return useSupabaseQuery<ProdigiOrder>(
		(client) =>
			client
				.from('prodigi_orders')
				.select('*')
				.eq('order_id', orderId ?? '')
				.order('created_at', { ascending: false }),
		[orderId]
	);
}

export function useLobOrders(orderId: string | undefined) {
	return useSupabaseQuery<LobOrder>(
		(client) =>
			client
				.from('lob_orders')
				.select('*')
				.eq('order_id', orderId ?? '')
				.order('created_at', { ascending: false }),
		[orderId]
	);
}
